<template>
  <el-form ref="form" label-width="120px" class="role-dialog">
    <el-form-item label="Name">
      <el-input v-model="name" ref="name" required></el-input>
    </el-form-item>
    <el-form-item label="Description">
      <el-input v-model="description" required></el-input>
    </el-form-item>
    <el-form-item label="Liquid Planner Role">
      <el-select v-model="selectedLpRole" value-key="attributes.name" placeholder="Select a role"> 
        <el-option v-for="role in lpRoles" :key="role.id" :label="role.attributes.displayName" :value="role"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="buttons">
      <el-button @click="cancel">Cancel</el-button>
      <el-button type="primary" @click="save" :disabled="!saveIsEnabled">Save</el-button>
    </el-form-item>
    <el-form-item label="View All Time Entries">
      <el-checkbox v-model="isAllTimeEntriesEnabled"></el-checkbox>
    </el-form-item>
    <el-form-item label="Edit All Time Entries">
      <el-checkbox v-model="isAllTimeEntriesEditable"></el-checkbox>
    </el-form-item>
    <el-form-item label="View Financials">
      <el-checkbox v-model="isFinancialsEnabled"></el-checkbox>
    </el-form-item>
    <el-form-item label="View All Tasks">
      <el-checkbox v-model="isAllTasksEnabled"></el-checkbox>
    </el-form-item>
    <el-form-item label="Disabled">
      <el-checkbox v-model="isEnabled"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>

export default {

  props: {
    save: Function,
    close: Function,
    role: Object
  },
  data () {
    return {
      name: null,
      description: null,
      lpRoles: this.$store.getters['roles/all'],
      selectedLpRole: null,
      isAllTimeEntriesEnabled: false,
      isAllTimeEntriesEditable: false,
      isFinancialsEnabled: false,
      isAllTasksEnabled: false,
      isEnabled: false
    }
  },
  computed: {
    saveIsEnabled () {
      return this.name && this.description
    }
  },
  mounted () {
    this.$nextTick(() => this.$refs['name'].focus())
  },
  created () {
    document.addEventListener('keypress', this.keypress)
  },
  destroyed () {
    document.removeEventListener('keypress', this.keypress)
  },
  methods: {
    keypress (e) {
      e.keyCode === 13 && this.save()
    },
    cancel () {
      this.close()
    },
    save () {
      this.close()
    }
  }
}
</script>

<style lang='scss'>
  @import "../styles/common.scss";

  .role-dialog {
    .buttons {
      float:right;
    }
    .el-form {
      margin-bottom:60px;

      input:invalid {
        border-color: $light-red;
      }
    }
  }
</style>